export default __webpack_public_path__ + "static/po-1fc4229d5f84f16503a49520befdef49.png";